import { render, staticRenderFns } from "./AuthGate.vue?vue&type=template&id=68d81c08&scoped=true&"
import script from "./AuthGate.vue?vue&type=script&lang=js&"
export * from "./AuthGate.vue?vue&type=script&lang=js&"
import style0 from "./AuthGate.vue?vue&type=style&index=0&id=68d81c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d81c08",
  null
  
)

export default component.exports